import { useMemo, useState } from 'react'

const DISSOLVE_DURATION = 150

const DISSOLVE_STYLE: React.CSSProperties = {
  transitionDuration: `${DISSOLVE_DURATION}ms`,
  animationDuration: `${DISSOLVE_DURATION}ms`,
  transitionProperty: 'opacity',
}

const useDissolveScreen = () => {
  const [dissolve, setDissolve] = useState<boolean>(false)

  const dissolveStyles = useMemo(() => {
    if (dissolve) {
      return {
        ...DISSOLVE_STYLE,
        opacity: 0,
      }
    }

    return {
      ...DISSOLVE_STYLE,
      opacity: 1,
    }
  }, [dissolve])

  return { dissolve, setDissolve, dissolveStyles, dissolveDuration: DISSOLVE_DURATION }
}

export default useDissolveScreen
